// @flow

import React from 'react'
import bindAll from 'lodash/bindAll'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'

type Props = {};

class Pricing extends React.Component<Props> {
	constructor() {
		super()

		bindAll(this, [
			'handleRegisterLink'
		])
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	handleRegisterLink(e: Object): void {
		e.preventDefault()

		if (process.env.NODE_ENV === 'development') {
			window.location = 'http://localhost:8000/register'
		} else if (process.env.NODE_ENV === 'beta') {
			window.location = 'https://beta.astrnt.co/register'
		} else {
			window.location = 'https://app.astrnt.co/register'
		}
	}

  render() {
    return (
			<main>
				<div className="bg-grey">
					<Header isNavbarFixed={true} />
					<section className="page-sticky-navbar">
						<div className="page-sticky-title vertical-item--center">
							<div className="container">
								<h2 className="heading1">Choose what's best for you</h2>
							</div>
						</div>
						<div className="container">
							<div className="centering">
								<div className="pricing__container">
									<div className="big-panel pricing__box">
										<div className="pricing-table">
											<div className="pricing-head">
												<h3 className="heading1">30 for 30</h3>
											</div>
											<div className="pricing-body">
												<ul className="checked-list">
													<li>30 candidate credits</li>
													<li>Valid for 30 days</li>
													<li>Unlimited jobs</li>
													<li>Unlimited questions</li>
													<li>Up to 5 team members</li>
													<li>Fast, effective hiring</li>
												</ul>
											</div>
										</div>
										<div className="pricing-action">
											<p className="heading3 normal m-b-24">Free Trial</p>
											<a
												onClick={this.handleRegisterLink}
												className="button button__secondary">
												Try for free
											</a>
										</div>
									</div>
									<div className="big-panel pricing__box">
										<div className="pricing-table">
											<div className="pricing-head">
												<h3 className="heading1">Start small</h3>
											</div>
											<div className="pricing-body">
												<ul className="checked-list">
													<li>50 candidate credits</li>
													<li>Valid for 12 months</li>
													<li>Unlimited jobs</li>
													<li>Unlimited questions</li>
													<li>Up to 5 team members</li>
													<li>Fast, effective hiring</li>
												</ul>
											</div>
										</div>
										<div className="pricing-action">
											<p className="heading3 normal m-b-24">$ 500</p>
											<a
												href="mailto:help@astrnt.co?subject=Request Start small"
												className="button button__secondary">
												Contact us
											</a>
										</div>
									</div>
									<div className="big-panel pricing__box">
										<div className="pricing-table">
											<div className="pricing-head">
												<h3 className="heading1">Scale-up</h3>
											</div>
											<div className="pricing-body">
												<ul className="checked-list">
													<li>Scoped for your unique needs</li>
													<li>Customized for you</li>
													<li>Deeper support</li>
													<li>Fixed price (annual)</li>
												</ul>
											</div>
										</div>
										<div className="pricing-action">
											<p className="heading3 normal m-b-24">Price to match your needs</p>
											<a href="mailto:help@astrnt.co?subject=Request Scale-up"
												className="button button__secondary">
												Contact us
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section>
						<div className="container">
							<p className="pricing-help-block"><i>* All prices are subject to 10% government tax</i></p>
							<div className="centering">
								<div className="pricing-botom">
									<div className="big-panel pricing-faq">
										<h3 className="heading4 bold uppercase m-b-24">Frequently asked question</h3>
										<ol className="readable number p-l-15">
											<li>
												<b>What is a candidate credit?</b>
												<p>A candidate credit is defined as the ability for a candidate to complete a session in Astronaut, i.e. if the candidate does not complete the questions your account will not be charged. It is 1 credit for 1 completed candidate.</p>
											</li>
											<li>
												<b>What does the 12 months validity mean?</b>
												<p>All of your candidate credits hold a 12 month validity and you are encouraged to use them before they expire. If you require flexibility for the period of time, please contact us at <a href="mailto:help@astrnt.co">help@astrnt.co</a>, we are here to help always. Also, see below regarding how to extend the validity of existing credits by purchasing new credits.</p>
											</li>
											<li>
												<b>What happens to my existing credits?</b>
												<p>When you top-up your credits, a new 12 month validity will be be applied to all your existing credits.</p>
											</li>
											<li>
												<b>How can I make payment?</b>
												<p>Our online payment gateway will be available shortly, but until this is possible please send your requirements to <a href="mailto:help@astrnt.co">help@astrnt.co</a>, and we will assist you. We will provide a quotation for your procurement team’s approval after which we will send you the invoice and tax documents with bank account details for payment.</p>
											</li>
											<li>
												<b>When can I use my newly bought credits?</b>
												<p>We operate on a trust basis and allow you to access your new credits right away. All we ask in return is a speedy payment in response to the invoice and tax documents. We may need to suspend your account if we don’t receive payment within 30 days of sending the invoice.</p>
											</li>
											<li>
												<b>My credits are currently in negative. Will I be billed twice?</b>
												<p>No, after you purchase new credits they will be applied to offset the deficit.</p>
											</li>
										</ol>
									</div>
									<div className="big-panel pricing-contact p-40">
										<h3 className="heading1 p-b-24 text-center">Not ready?</h3>
										<ul className="list-plain">
											<li>-<a href={`/astronaut-for/professionals`} className="underline text-inherit">See case studies</a></li>
											<li>-<a href="mailto:help@astrnt.co" className="underline text-inherit">Talk to us</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</section>
				<Footer />
				</div>
			</main>
		)
  }
}

export default Pricing
